<top-navigation class="d-print-none"></top-navigation>

<main>
    <main-banner [title]="article?.title"></main-banner>

    <div class="container-fluid my-5 generic-page-wrapper">
        <div class="container-xxxl">
            <div class="row">
                <div class="col-xl-10 mx-auto body fs-md-18 text-link" [innerHTML]="article?.bodyText"></div>
            </div>
        </div>
    </div>
</main>

<app-footer></app-footer>
